'use client';

import { useState } from 'react';
import { cn, tv } from '../_lib/utils';
import { Container } from '../Container';
import { CustomerCardPopup, CustomerCardPopupProps } from '../CustomerCard';
import { Text } from '../Text';
import { type Brands } from '../Theme';

const styles = tv({
	slots: {
		items:
			'flex justify-around shrink-0 gap-responsive-md min-w-full animate-ticker group-hover/customersTicker:[animation-play-state:paused]',
		card: 'w-[calc(var(--width)/var(--count)-var(--gap)*var(--count))] h-full',
	},
	variants: {
		paused: {
			true: {
				items: '[animation-play-state:paused]',
			},
		},
	},
});

export type CustomersTickerProps = {
	className?: string;
	defaultBrand?: Brands;
	items: CustomerCardPopupProps[];
	overline?: string;
};

export function CustomersTicker(props: CustomersTickerProps) {
	const [pauseTicker, setPauseTicker] = useState(false);
	const { items, card } = styles({ paused: pauseTicker });

	return (
		<div className={cn('overflow-hidden w-screen flex flex-col gap-responsive-4xl', props.className)} data-component='CustomersTicker'>
			{props.overline && (
				<Container className={`w-full text-center`}>
					<Text as='h2' className={`text-text-brand`} styleType='label-md'>
						{props.overline}
					</Text>
				</Container>
			)}
			<div
				className={`group/customersTicker [--count:4] [--gap:var(--responsive-md)] [--width:90rem] flex gap-responsive-md relative select-none`}
			>
				<ul className={items()}>
					{props.items?.map((item, index) => (
						<li className={card()} key={`customers-ticker-1-${index}`}>
							<CustomerCardPopup {...item} setPauseTicker={setPauseTicker} defaultBrand={props.defaultBrand} />
						</li>
					))}
				</ul>
				<ul className={items()} role='presentation'>
					{props.items?.map((item, index) => (
						<li className={card()} key={`customers-ticker-2-${index}`}>
							<CustomerCardPopup {...item} setPauseTicker={setPauseTicker} defaultBrand={props.defaultBrand} />
						</li>
					))}
				</ul>
			</div>
		</div>
	);
}
